import { render, staticRenderFns } from "./section.component.html?vue&type=template&id=a42f861c&scoped=true&"
import script from "./section.component.ts?vue&type=script&lang=ts&"
export * from "./section.component.ts?vue&type=script&lang=ts&"
import style0 from "./section.component.scss?vue&type=style&index=0&id=a42f861c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42f861c",
  null
  
)

export default component.exports